import { AxleErrorBoundary } from '@/fetching/errorBoundaries';
import { FeatureFlag } from '@/types/featureFlag';
import { useFeatureFlagEnabled } from '@/utils/useFeatureFlagEnabled';
import { Suspense, lazy } from 'react';

// Loaded only when the flag is on, so organizations without it never download the palette.
const CommandPalette = lazy(() =>
    import('./CommandPalette').then((module) => ({ default: module.CommandPalette })),
);

/** Mounts the command palette for organizations that have the flag. */
export const CommandPaletteMount = () => {
    const enabled = useFeatureFlagEnabled(FeatureFlag.DASHBOARD_COMMAND_PALETTE_MVP);

    if (!enabled) {
        return null;
    }

    // The palette is optional, so a failed load stays here instead of reaching the app-level boundary.
    return (
        <AxleErrorBoundary fallback={<></>}>
            <Suspense fallback={null}>
                <CommandPalette />
            </Suspense>
        </AxleErrorBoundary>
    );
};
